import { HelpArea } from '@/core/domain/helpcenter/HelpAreas/HelpAreas.types';
import { Card, Typography } from 'antd';
import { Link } from 'react-router-dom';

interface Props {
  area: HelpArea;
}

const HelpCenterAreaCard: React.FC<Props> = ({ area }) => {
  return (
    <Link to={`/helpCenter/${area.id}`}>
      <Card
        style={{ borderRadius: 10, overflow: 'hidden' }}
        bodyStyle={{
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 150,
        }}
      >
        {!!area.banner && (
          <img
            src={area.banner}
            style={{
              objectFit: 'cover',
              objectPosition: 'center',
              width: '100%',
              height: '100%',
            }}
          />
        )}

        {!area.banner && (
          <Typography.Title
            level={4}
            style={{ margin: 0, marginTop: 10, textAlign: 'center' }}
          >
            {area.name}
          </Typography.Title>
        )}
      </Card>
    </Link>
  );
};

export default HelpCenterAreaCard;
